// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pubpicker {
  position: relative;
}

.pubpicker-dropdown {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50px;
  z-index: 2;
  border-right: 1pt solid #d0d5dd;
  border-radius: 8px;
  background-color: white;
  min-height: 100%;
  min-width: 340px;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 10px;
  padding-bottom: 10px;
}

.pubpicker-dropdown button {
  width: 296px;
  padding: 10px 18px;
  border: 2px solid transparent;
  border-radius: 15px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #590b8a;
  color: #ffffff;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pubpicker-dropdown hr {
  border: 0;
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #eff2f7;
  background: #999;
}
.pubpicker-dropdown button:hover {
  opacity: 0.8;
}

.pubpicker-dropdown__radio-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px 10px 15px;
  font-size: 18px;
  color: #505050
}

.pubpicker-dropdown__radio-div:hover {
    cursor: pointer;
  }

.pubpicker-dropdown__radio-div input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  border-radius: 50%;
  border: 1.5px solid #a9a9a9;
  width: 20px;
  height: 20px;
  position: relative;
  outline: none;
}

/* after = inner solid circle of radio button */

/* if checked */
.pubpicker-dropdown__radio-div input:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background-color: #590b8a;
  border-radius: 50%;
}

.pubpicker .button__white {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/PubPicker.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf;AAIF;;AAHE;IACE,eAAe;EACjB;;AAGF;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA,+CAA+C;;AAE/C,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".pubpicker {\n  position: relative;\n}\n\n.pubpicker-dropdown {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 50px;\n  z-index: 2;\n  border-right: 1pt solid #d0d5dd;\n  border-radius: 8px;\n  background-color: white;\n  min-height: 100%;\n  min-width: 340px;\n  box-shadow: 0px 3px 6px #00000029;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.pubpicker-dropdown button {\n  width: 296px;\n  padding: 10px 18px;\n  border: 2px solid transparent;\n  border-radius: 15px;\n  font-weight: bold;\n  font-size: 15px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #590b8a;\n  color: #ffffff;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.pubpicker-dropdown hr {\n  border: 0;\n  height: 1px;\n  width: 100%;\n  border-bottom: 1px solid #eff2f7;\n  background: #999;\n}\n.pubpicker-dropdown button:hover {\n  opacity: 0.8;\n}\n\n.pubpicker-dropdown__radio-div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px 10px 15px;\n  font-size: 18px;\n  color: #505050;\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.pubpicker-dropdown__radio-div input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: #fff;\n  border-radius: 50%;\n  border: 1.5px solid #a9a9a9;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  outline: none;\n}\n\n/* after = inner solid circle of radio button */\n\n/* if checked */\n.pubpicker-dropdown__radio-div input:checked::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 8px;\n  background-color: #590b8a;\n  border-radius: 50%;\n}\n\n.pubpicker .button__white {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
